import { useState, useEffect, useCallback } from 'react';
import { navLinks } from '@/mocks/home';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 60);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const handleNavClick = (id: string) => {
    setMobileOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60' : 'bg-transparent'}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#hero" className="flex items-center gap-2 flex-shrink-0" onClick={(e) => { e.preventDefault(); handleNavClick('hero'); }}>
            <div className="w-8 h-8 md:w-9 md:h-9 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-fire-fill text-background-50 text-lg"></i>
            </div>
            <span className="font-heading font-bold text-lg md:text-xl text-foreground-900 whitespace-nowrap">黑料每日大赛</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.id); }}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="hidden md:flex items-center gap-3">
            <a
              href="#ranking"
              onClick={(e) => { e.preventDefault(); handleNavClick('ranking'); }}
              className="px-5 py-2.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              查看排行榜
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-800"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.id}
                href={`#${link.id}`}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.id); }}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50 rounded-lg transition-colors"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#ranking"
              onClick={(e) => { e.preventDefault(); handleNavClick('ranking'); }}
              className="mt-2 px-5 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors text-center"
            >
              查看排行榜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}